// eslint-disable-next-line import/no-anonymous-default-export
export default {
    translation: {
        next_btn: "继续",
        logout: "登出",
        back_btn: "返回",

        errors: {
            invalid_password: "无效的密码。 长度为6-15个字符，包含一个大写字母、一个小写字母和一个数字。",
            hear_us_error: "请选择您是在哪里听说我们的。",
            email_validation: "电子邮件必须包含“@”符号",
            required_field: "此字段是必需的。",
            conf_email_error: "电子邮件和确认电子邮件不匹配",
            conf_password_error: "密码和确认密码不匹配",
            canadian_email_error: "我们不接受加拿大电子邮件地址",
            enter_characters: "输入不超过 11 个字符。",
            tax_enter_characters: "输入不超过 10 个字符。",
            conf_ssn_error: "SSN 和确认 SSN 不匹配",
            conf_tax_error: "Tax ID 和确认 Tax ID 不匹配",
            years_old_error: "你必须年满 18 岁。”",
            exp_date_error: "必须晚于当前日期。",
            exp_issue_date_error: "必须晚于签发日期.",
            select_country_error: "请选择一个国家。",
            exp_earlier_date_error: "必须早于当前日期。",
            liquid_assets_error: "流动资产不能大于净值。",
            invalid_signature: "您的签名必须与您在申请表上的姓名一致",
            indicate_error: "所有权百分比必须加至 100%",
            liquid_error: "如果您的流动资产净值低于 20,000 美元，我们无法批准您的保证金。 请选择现金账户。",
            valid_date: "请输入 MM/DD/YYYY 格式的有效日期。",
            custodial_year: "您必须未满 18 岁",
            main_user_ssn: "不能与主用户的SSN相同",
            zip_code_format: "邮政编码无效。 必须是 NNNNN 或 NNNNN-NNNN"
        },

        register: {
            user_registration: "新用户注册",
            for_limited: "打开一个ChoiceTrade账户最少需要100美元。如果您申请保证金账户，最低金额为2,000美元。",
            username: "用户名",
            email: "电子邮件*",
            password: "秘密*",
            confirm_password: "确认密语*",
            hear_us: "你从哪里知道我们的？",
            citizen_status: "公民身份",
            type_account: "选择要打开的帐户类型。",
            individual: "个人",
            joint_account_type: "联名账户类型",
            custodial: "保管的",
            ira: "IRA",
            specialty_account_type: "专业账户类型",
            already_sign_in: "已经开始申请了吗？ 登入。",
            important_info: "有关开设新账户程序的重要信息：根据美国法律，我们需要要求您提供带照片的身份证明，例如护照或驾驶执照，以验证您的身份。 非美国客户必须发送护照。 如果非美国客户没有护照，则可以使用驾驶执照或国民身份证。 您还将被要求提供用于为 ChoiceTrade 账户注资的银行账户的银行对账单，并且银行对账单上的姓名和地址必须与您的账户申请中的姓名和地址一致。 您可能还需要提供水电费账单以验证您的地址。 这些文件将用于验证您的身份。",
        },

        personal: {
            welcome: "欢迎",
            welcome_pls: "请在下面继续您的应用程序。",
            personal_info: "个人信息",
            title: "标题",
            mr: "先生。",
            ms: "女士。",
            mrs: "太太。",
            dr: "博士",
            first_name: "名字*",
            last_name: "姓*",
            date_of_birth: "出生日期 MM/DD/YYYY",
            ssn: "SSN XXX-XX-XXXX",
            confirm_ssn: "确认 SSN XXX-XX-XXXX",
            mobile_phone: "移动电话 (国家代码和号码)",
            marital_status: "婚姻状况",
            single: "单",
            married: "已婚",
            divorced: "离婚",
            widow: "寡妇",
            iden_type: "识别类型",
            state_dl: "国家DL",
            state_id: "州ID",
            passport: "护照",
            iden_number: "识别号码",
            issue_date: "发行日期MM / DD / YYYY",
            expiration_date: "到期日期MM / DD / YYYY",
            permanent_address: "永久地址",
            address2: "地址2",
            city: "市",
            select_country: "选择国家",
            zip_code: "邮政编码",
            select_state: "選擇國家",
            different_address: "我的邮寄地址是不同的",
            mailing_address: "邮寄地址",
            mailing_address2: "邮寄地址2",
            mailing_city: "市",
            mailing_country: "选择国家",
            mailing_zip_code: "邮政编码",
            mailing_state: "選擇國家",
            identification: "鉴别"
        },

        financial: {
            thanks: "谢谢",
            need_financial_info: "现在，我们需要你的财务信息",
            financial_info: "财务信息",
            employment_status: "就业状况",
            employed: "就业",
            self_employed: "自雇",
            retired: "退休",
            homemaker: "家庭主妇",
            student: "学生",
            unemployed: "失业的",
            school_name: "学校名称",
            occupation: "占用",
            accounting: "會計",
            agriculture: "农业",
            banking_and_finance: "银行和金融",
            clerical: "文员",
            construction: "文书",
            consulting: "咨询",
            customer_service: "客户服务 - 呼叫中心",
            education: "教育",
            engineer: "工程师",
            government: "政府",
            healthcare: "卫生保健",
            hotel_restaurant: "酒店和餐厅",
            information: "信息技术",
            internet: "互联网和电子商务",
            legal: "法律",
            management_executive: "管理和执行",
            manufacturing: "制造业",
            marketing: "营销",
            media: "媒体 - 新闻",
            non_profit: "非营利",
            real_estate: "房地产",
            retail: "零售",
            sales: "销售",
            science: "科学",
            security: "社会保险/养老金",
            sports: "体育",
            travel: "旅游和旅游",
            wholesale: "批发",
            company_name: "公司名",
            business_address: "公司地址",
            city: "市",
            select_country: "选择国家",
            zip_code: "邮政编码",
            select_state: "選擇國家",
            source_of_income: "收入的主要来源",
            job: "工作",
            personal_saving: "个人储蓄",
            spouse: "配偶/父母",
            inheritance: "遗产",
            investment: "投资",
            retirement_plan: "退休计划",
            real_estate_investment: "房地产投资",
            stock_retirement: "股票退休年金",
            family_wealth: '家庭财富',
            passive_income: "被动收入",
            royalties: "特许权使用费",
            property_income: "财产性收入",
            portfolio_income: "组合收益",
            other: "其他",
            source_of_wealth: "财富的主要来源",
            personal_income_saving: "个人收入/保存",
            sale_of_business: "销售业务",
            annual_income: "年收入",
            liquid_assets: "流动资产",
            over: "超过",
            net_worth: "净值",
            sold_business_name: "出售的企业名称",
            sale_amount: "销售金额",
            date_sold: "出售日期"
        },

        affiliation: {
            welcome: "欢迎",
            affiliated: "接下来，我们需要知道，如果你是以下任一关联。",
            affiliation_information: "合作咨询",
            yes: "是",
            no: "没有",
            aff_company_name: "公司名",
            your_position: "您现在的位置",
            aff_person_name: "附属人姓名",
            agent_list: "請列出代理進程的服務",
            financial_regulator: "请扫描并通过电子邮件显示与贵国的金融监管机构会员资格的文件副本service@选择贸易.com",
            political_organization: "请提供官方和直系亲属（包括前配偶）和相关外国政治性组织的名字呢？",
            name: "姓名",
            organization: "组织",
            ownership_disclosure: "股权披露",
            ownership_disclosed: "根据第14B-1的证券交易法（三）。我们被要求披露发行人客户的姓名，地址和安全位置谁是发行人的证券，除非客户对象的实益拥有人。请在这里检查，如果你不想要的所有权披露做。",
            privacy_and_policy: "我已阅读并同意 ChoiceTrade ",
            privacy_policy: "隐私政策",
            are_member: "您或您的家庭成员的董事，10％的股东或上市公司的官员？",
            NFA_or_CFTC: "您或您的家庭成员是否附属于或受雇于在美国或任何美国交易所或自律组织（包括 SEC、FINRA、NFA 或 CFTC）开展业务的注册经纪人/交易商、保险公司、银行、投资顾问?",
            foreign_shell: "这是正在申请代表外国空壳银行提交？",
            owner_affiliated: "该帐户拥有者附属于外国空壳银行？",
            owner_offer: "是否帐户所有者外国空壳银行提供服务？",
            bankruptcy_proceeding: "你是否曾经破产程序，破产或类似的诉讼主体？",
            commodity_account: "你是否曾经在涉及证券或商品账户的法律纠纷，仲裁或赔偿诉讼？",
            commodity_firm: "你有没有关闭，或左休眠状态，一个账户在证券或商品的公司未付余额？",
            business_with_you: "您或您会从谁是不是该帐户将被用于该帐户的寿命期间该帐户资金的所有者，任何个人或实体获得资金？ （如果你打算到该帐户在任何时间与别人的钱资助那么我们很抱歉我们不能跟你做生意。",
            financial_institution: "这是正在申请代表外国金融机构提交的？",
            close_associate: "这是正在申请代表的现任或前任高级政治人物的提交（参见定义）或直系家庭成员或亲密伙伴？",
        },

        account: {
            welcome: "欢迎",
            option_trading: "现在考虑您希望为您帐户.你的期权交易经验应该符合你的需要的期权交易水平的期权交易和保证金交易的能力。如果你没有经验，你将无法达到的更高水平的期权交易。",
            account_privileges: "帐户权限",
            account_profile: "选择一个帐户的个人资料",
            cash_margin: "现金保证金",
            cash: "现金",
            cash_margin_accounts: "现金保证金账户有超过现金账户额外的特权。翻转图标查看详细信息。",
            specify_trading_level: "请指定您想要的该账户的期权交易水平。 大多数级别的期权交易能力都需要投机投资目标，但备兑看涨期权除外。 请在下面注明您想要的期权交易程度。",
            option_trading_level: "具体选项目的，并要求期权交易等级",
            choose_one: "选一个",
            level1: "目标：收入：等级1 ：写涵盖呼叫",
            level2: "目的：投机：2级：等级1+买入看涨和看跌期权",
            level3: "目的：猜测：等级3 ：2级+借记价差",
            level4: "目的：猜测： 4级： 3级+信用利差",
            level5: "目的：猜测： 5级： 4级+裸露股票期权",
            level6: "我不希望添加期权交易capabilty此帐户",
        },

        experience: {
            welcome: "欢迎",
            investment_experience: "现在请告诉我们您的投资经验和投资目标。",
            previous_investment: "上一页投资经验",
            stocks: "股票",
            year: "年",
            average_size: "普通大小",
            average_number: "平均人数",
            options: "选项:",
            investment_objective: "投资目标",
            speculative_activity: "请点击对您最重要的投资目标。 由于您在申请过程中之前选择的帐户类型和功能，前两个目标可能会被禁用。 例如，投资细价股票、使用保证金或交易期权（期权级别 1 除外）本质上是投机性的，需要较高的风险承受能力。 如果您的投资目标风险承受能力较低，并且您希望做出这些选择，则必须返回并取消选中这些功能。",
            objective: "客观的：",
            risk_tolerance: "投资目标。 收入。 风险承受能力：中等。 时间范围：不到 5 年（收入投资目标表明您寻求从投资中产生收入，并且对历史上显示本金价值损失风险低于其他目标的投资感兴趣。典型投资的一些示例 可能包括高质量、短期固定收益产品和备兑看涨期权。您全权负责确定您所做的每项投资是否符合您的投资目标和风险状况。ChoiceTrade 不会为您监控这一点。）",
            capital_appreciation: "投资目标：资本增值。 风险承受能力：投机。 （资本增值的投资目标表明，您寻求随着时间的推移增加投资的本金价值，并愿意投资于历史上表现出高于平均水平的本金损失风险的证券来实现这一目标。一些例子 典型投资可能包括普通股、较低质量、中期固定收益产品、股票共同基金和指数基金。您全权负责确定您所做的每项投资是否符合您的投资目标和风险状况。ChoiceTrade 不会监控 这是为您准备的。如果您选择此目标，您将无法购买场外交易（便士）股票或期权。）",
            time_horizon: "投资目的：投机。 风险承受能力：投机。 时间范围。 少于5年（投机投资目标表明您寻求投资本金价值的显着增加，并愿意通过投资于历史上表现出高度损失风险的证券来接受相应的更大风险。 追求这一目标的本金价值，有时超过您的本金投资。您可能会寻求利用短期交易机会，这可能涉及快速建立和清算头寸。典型投资的一些例子可能包括质量较低、长期 固定收益产品、首次公开募股、波动性或低价普通股、购买或出售看跌期权或看涨期权、股票或指数的价差、跨式组合和/或组合，以及短期或日间交易策略的使用。 全权负责确定您所做的每项投资是否符合您的投资目标和风险状况。ChoiceTrade 不会为您监控这一点。 如果您希望交易细价股票或期权（除备兑看涨期权外），或者如果您希望进行即日交易（任何类型的证券），这是我们在您的账户被允许交易这些投机证券之前接受的唯一目标。）",
            document_delivery: "文件交付",
            additional_fees: "我同意通过电子邮件而不是邮寄接收以下文件（通过邮寄接收纸质文件需要支付额外费用）",
            trade_conf_email: "通过电子邮件进行交易确认。",
            account_statement_email: "通过电子邮件发送帐户报表。",
            proxy_statement_email: "通过电子邮件发送的代理声明。",
            prospectuses_email: "通过电子邮件发送招股说明书。",
            tax_document_email: "通过电子邮件发送税务文件。",
        },

        conditions: {
            thanks: "谢谢",
            terms_condition: "现在，我们需要您查看并同意以下每项协议的一些条款和条件。 （请打开每个选项卡并选中该框）",
            financial_information: "披露",
            customer_agreement: "客户协议",
            conditions_governing: "我声明我已阅读、理解并同意中包含的管理此帐户的条款和条件",
            conditions_governing2: "我同意受当前有效的条款和条件的约束，这些条款和条件可能会不时修订，恕不另行通知。 我保证，据我所知和所信，我在申请中输入的所有信息都是正确的。 如果将来有变化，我同意及时以书面形式通知ChoiceTrade。",
            arbitration_agreement: "我了解该账户受客户协议第 18 和 19 段中规定的仲裁协议管辖。 我确认已收到仲裁协议和管理我的帐户的客户帐户协议。 我确认我已阅读并理解主动交易风险披露声明、保证金披露声明和 ChoiceTrade 隐私声明。 我理解并承认 (i) 此账户申请并非根据任何招揽而提出，(ii) ChoiceTrade 不隶属于其清算公司或其代理，并且 (iii) 本文中的任何内容均不构成任何证券的要约或招揽， 在任何司法管辖区提供或销售产品或服务将违反当地法律或法规。我承认 ChoiceTrade 不会就特定证券或投资策略的潜在价值或适用性提供投资、税务、法律或会计建议 。",
            fee_acknowledgement: "费用确认",
            service_fee: "有些平台涉及每月服务费。 我承认并同意通过授权 ChoiceTrade 从我的账户中扣款来支付服务费。 我承认可以根据协议支付中间人费用。",
            margin_agreement1: "保证金协议 (Velox)",
            margin_agreement: "保证金协议",
            margin_agreement2: "保证金协议（曲率）",
            margin_terms: "我同意保证金补充的所有条款。 我承认我的保证金账户证券可能由我借用或借给他人。",
            margin_risk: "保证金风险披露声明",
            options_agreement: "期权协议",
            any_material_change: "我同意就我的财务状况和/或投资目标的任何重大变化向 CHOICETRADE 提出建议。 我同意选项补充的所有条款。 我承认我已阅读以下链接的披露文件“标准化期权的特征和风险”，并且了解期权交易固有的特殊风险。",
            option_disclosures: "期权披露",
            options_supplement: "选项补充",
            taxpayer_id_number: "纳税人 ID 号证明（替代 W-9）（如果您不是纳税美国人，请跳过此部分）",
            notified_irs: "如果 IRS 通知您可以免除备用预扣税，请选中此框。 （如果本节不适用于您或者您不是纳税美国人，请跳过本节）",
            penalty_of_perjury: "本人特此声明：如作伪证，愿受处罚。",
            number_1: "1. 本申请表上显示的号码是我正确的纳税人识别号码（或者我正在等待向我发放号码）并且",
            number_2: "2. 我无需缴纳备用预扣税，因为 (a) 我无需缴纳备用预扣税，或者 (b) 我没有收到国税局 (IRS) 的通知，告知我因失败而需要缴纳备用预扣税 报告所有利息或股息，或 (c) IRS 已通知我，我不再需要缴纳备用预扣税（不适用于房地产交易、支付的抵押贷款利息、担保财产的收购或放弃、对个人的捐款） 退休账户 (IRA) 以及利息和股息以外的付款。）",
            number_3: "3. 我是美国人（包括美国居民）。 认证说明 - 如果您已收到 IRS 通知，由于您未能在纳税申报表上报告所有利息和股息，您目前需要缴纳备用预扣税，则必须划掉上述第 2 项。）",
            clearing_authorization: "清算公司授权",
            client_auth_condition: "我们的清算公司提供查看各种报告的权限。 请选中此框以授权他们向您提供此服务。",
            agreew8_heading: "W8-BEN 表格纳税身份证明",
            agreew8_text: "我同意上述认证。 我承认我必须做出 IRS W8-BEN 表格伪证声明中包含的声明，并且我通过下面的签名做出此声明。 我特此同意以电子方式提交我的 W8-BEN 表格，并允许 ChoiceTrade 与其清算公司共享该表格。",
            w8_form: "W8-表格",
            finder_heading: "外国发现者协议",
            finder_text1: "下方签名的客户承认并同意以下各项：",
            finder_text2: "我/我们不是美国公民或居民。 如果代表实体申请，该实体不是美国实体，也不是在美国注册的。",
            finder_text3: "ChoiceTrade 没有邀请我在 ChoiceTrade 开设账户。 为了让我在 ChoiceTrade 开展业务，ChoiceTrade 不需要在我的管辖范围内注册",
            finder_text4: "我的账户受到补偿安排的约束，根据该安排，ChoiceTrade 将向非美国发现者支付费用",
            finder_text5: "（“发现者”）与交易相关的补偿。 除非下面另有说明，否则我的佣金时间表是 ChoiceTrade 的常规时间表。 发现者不是 ChoiceTrade 的经纪人、员工或代理人，我/我们不会就我/我们与 ChoiceTrade 的业务与发现者打交道。 除了 Finder 关系之外，ChoiceTrade 与 Finder 没有任何从属关系。 我/我们将就我/我们的 ChoiceTrade 账户的所有方面直接与 ChoiceTrade 打交道。",
            finder_text6: "通过签署本申请，我/我们理解、承认并同意上述规定，自申请之日起生效。",
            privacy: "隐私",
            foreignfinder: "ChoiceTrade 将向非美国支付 发现者，Red Information Technology Ltd. 支付我支付的 ChoiceTrade 部分佣金和保证金利息的交易相关利润的一半。 该比率可能会发生变化。"
        },

        review: {
            next: "下一个，,",
            review_info: "请检查您的信息。",
            click_here: "点击这里",
            print_page: "打印页面。",
            review_app: "审核申请",
            registration: "登记：",
            edit: "编辑",
            citizen_status: "公民身份:",
            account_type: "账户类型：",
            personal_info: "个人信息：",
            title: "标题:",
            first_name: "名字*:",
            last_name: "姓*:",
            date_of_birth: "出生日期:",
            ssn: "社会保障号:",
            marital_status: "婚姻状况:",
            permanent_address: "永久地址:",
            address2: "地址2:",
            city: "市:",
            country: "国家:",
            zip_code: "邮编/邮政编码:",
            employment: "就业:",
            employment_status: "就业状况:",
            contact_info: "联系方式:",
            phone: "日间电话:",
            email: "电子邮件:",
            financial_info: "财务信息:",
            source_of_income: "收入的主要来源:",
            annual_income: "年收入:",
            liquid_assets: "流动资产:",
            net_worth: "净值:",
            account_privileges: "账户权限:",
            investment_account_type: "投资账户类型:",
            investment: "投资账户类型：",
            mailing_address: "邮寄地址:",
            perm_address: "与永久地址相同:",
            mailing_address2: "地址2:",
            mailing_city: "城市:",
            mailing_state: "状态:",
            mailing_country: "国家:",
            mailing_zip_code: "邮编/邮政编码:",
            previous_investment: "过往投资经验:",
            stocks: "股票:",
            year: "年:",
            average_size: "普通大小:",
            average_number: "年平均交易笔数:",
            options: "选项:",
            investment_objective: "投资目标:",
            investment_experience_text: "投资目的：投机。 风险承受能力：投机。 时间范围。 5年以内",
            specific_option_level: "具体期权目标和要求的期权交易水平:"
        },

        signature: {
            sign_and_submit: "签署并提交",
            signature: "签名:",
            primary_account: "主要账户所有者",
            signature_line: "请在签名行输入您的名字和姓氏来签署文档。",
            arbitration_agreement: "我了解该账户受客户协议第 18 和 19 段中规定的仲裁协议管辖。 我确认已收到仲裁协议和管理我的帐户的客户帐户协议。",
            terms_and_conditions: "我声明我已阅读、理解并同意客户协议中包含的管理此帐户的条款和条件。 我同意受当前有效的条款和条件的约束，这些条款和条件可能会不时修订，恕不另行通知。 我保证，据我所知和所信，我在申请中输入的所有信息都是正确的。 如果将来有变化，我同意及时以书面形式通知ChoiceTrade。 我确认我已阅读并理解 ",
            risk_disclosure_statement: "Active Trading Risk Disclosure Statement, the Margin Disclosure Statement and the ChoiceTrade Privacy Statement.",
            service_fee: "我理解并承认 (i) 此账户申请并非根据任何招揽而提出，(ii) ChoiceTrade 不隶属于其清算公司或其代理，并且 (iii) 本文中的任何内容均不构成任何证券的要约或招揽， 在其提供或销售违反当地法律或法规的任何司法管辖区的产品或服务。 我承认 ChoiceTrade 不会就特定证券或投资策略的潜在价值或适用性提供投资、税务、法律或会计建议。 有些平台涉及每月服务费。",
        },

        welcome_to: {
            welcome_to: "欢迎来到精选贸易",
            upload: "上传",
            account_funding: "账户资金",
            funding_instruction: "一旦您的帐户获得批准并且您拥有帐号，您就可以立即为其注入资金。 请点击此处获取资金说明。",
            click_here: "请点击此处获取资金说明",
            attention: "注意：需要额外表格！ 请按照以下说明进行操作。 为了开始您的申请的审核过程，请提供以下文件。 您可以使用下面的上传功能安全地将文件上传给我们。 （如果您无法上传文件，您可以单独通过电子邮件发送至 service@choicetrade.com，我们会将其附加到您的申请中。如果您通过电子邮件发送，请务必从您在帐户中提供的电子邮件地址发送 应用..",
            application: "美国申请人：请提交您当前驾驶执照的副本。 （过期的许可证将不被接受）。 请发送您将用于为您的账户注资的最新银行对账单的首页。 如果您的账户将使用多家银行，请提供所有银行的此信息。 请注意：您的银行对账单上的姓名和地址必须与您申请时使用的信息完全匹配。 如果您从与我们为您存档的信息不符的帐户发送资金，您的资金将被退回，并且您将产生银行费用和其他费用。",
            non_resident: "非居民：请提交您当前护照的复印件。 仅当您这样做时，请发送您将用于为帐户注资的最新银行对账单的第一页。 如果您的账户将使用多家银行，请提供所有银行的此信息。 请注意：您的银行对账单上的姓名和地址必须与您申请时使用的信息完全匹配。 您需要发送地址证明，例如其中一个地址的公用事业账单。 如果您从与我们为您存档的信息不符的帐户发送资金，您的资金将被退回，并且您将产生银行费用和其他费用。",
            complete_app: "恭喜！ 您的申请已完成。 目前，这里有一个申请确认号码供参考：",
            complete_app_continue: "（这不是您的帐号）。 在我们审核您的申请之前，您只需要提交一些文件。 请按照以下说明进行操作。 一旦您提交附加文件，ChoiceTrade 将审核您的申请。 一旦获得批准，您将获得一个帐号、登录信息，并通过电子邮件获得资金说明。 在您拥有帐号之前，请不要启动资金。 帐户审批过程通常会在几个小时内完成，但如果在非高峰时间（例如周日凌晨 2 点）提交申请，则该过程将需要更长的时间。"
        },

        welcome_back: {
            welcome_back: "欢迎回来！",
            click_below: "单击下面可恢复已在进行的申请。",
            app_in_progress: "您已完成或正在进行申请。 单击任意一项继续。",
            individual: "个人",
            second_app: "提交第二次申请",
            delete: "删除",
            account: "帐户",
            started: "开始于",
            completed: "您已完成",
            completed_of: "共 7 个步骤"
        },

        logout_modal: {
            logout_text: "如果您完成了申请，请单击“确定”，要留在页面上，请单击“取消”。",
            ok: "好的",
            cancel: "取消"
        },

        login: {
            login: "登录",
            enter_email: "输入电子邮件",
            enter_password: "输入密码",
            cancel: "取消",
            forget_password: "忘记密码了吗？",
            forgot_password: "忘记密码",
            retrieve_password: "要检索您的单词，请在下面输入您的电子邮件地址",
            send_message: "我们已将密码重置链接发送到您的电子邮件",
            acc_not_found: "找不到帐户！",
            user_not_found: "未找到用户！",
            email: "电子邮件",
            new_password: "新密码",
            confirm_new_password: "确认新密码",
        },

        modals: {
            ind_modal: {
                joint1: "生存権のある共同入居者",
                joint2: "一般共有者",
                joint3: "完全な共同所有",
                joint4: "共同社会による所有権",
            },

            ira_modal: {
                ira: "我们抱歉，但目前我们不接受IRA账户。",
                close: "关闭"
            },

            special_modal: {
                corporate: "企业",
                non_profit: "非营利",
                invest_club: "投资俱乐部",
                limited_company: "有限责任公司",
                partnership: "合伙",
                partnership_corp: "合伙",
                trust: "相信",
                c_corporation: "C-公司",
                s_corporation: "S-公司",
                trust_ssn: "是否使用信托受托人的SSN？",
                trust_id: "是否信任有自己的税号？",
                close: "关闭",
                member: "成员"
            }
        },

        specialty: {
            trust_company_name: "信托、公司或组织名称",
            country_of: "公司/组织所在国家/地区",
            for_accounts: "对于实体账户和 IRAS，我们需要有关受托人、授权签署人或受益人的更多信息。",
            middle_name: "中间名字",
            entity_role: "实体角色",
            president: "总统",
            treasurer: "财务主管",
            vice_president: "副总裁",
            secretary: "秘书",
            add_signer: "我需要添加另一个授权签名者"
        },

        custodial: {
            thanks: "谢谢",
            provide_info: "现在请向我们提供您为其设置此帐户的未成年人的信息。"
        },

        joint: {
            thanks: "谢谢",
            joint_info: "联合业主个人信息",
            provide_joint_info: "你已经完成了这个应用程序。点击下面的按钮来查看或下载接下来，请为每一个在account.our帐户形式的联合所有者提供信息。",
            joint_account_spouse: "是联名账户所有者主账户持有人的配偶？",
            joint_primary_address: "是主地址一样帐户所有者？",
            yes: "是",
            no: "没有",
            evening_phone: "傍晚的电话",
            are_you_member: "您或您的家庭成员是否附属于或受雇于在美国或任何美国交易所或自律组织（包括 SEC、FINRA、NFA 或 CFTC）开展业务的注册经纪人/交易商、保险公司、银行、投资顾问?",
            indicate: "请注明所有权％，低于每一个人"
        },

        tooltip: {
            country_tooltip: "如果您所在的国家/地区未列出，我们将无法接受您的申请。 如果您有疑问，请发送电子邮件至 service@choicetrade.com。 根据加拿大法律，居住在加拿大的加拿大公民不得在美国经纪商处开设账户。",
            state_tooltip: "ChoiceTrade 在美国 50 个州和华盛顿特区注册，但不在美国领土注册。 很遗憾，我们无法接受来自波多黎各、关岛、美属维尔京群岛和其他美国领土的申请人。",
            country_tooltip_message: "为什么我的国家/地区没有列出？",
            state_tooltip_message: "为什么我的州没有列出？"
        }
    },
}